<div class="main-content mat-dialog-container-dialog">
  <div class="container-fluid container-fluid-dialog">
    <div class="card card-inside card-inside-dialog">
      <div class="card-header card-header-danger">
        <div class="row">
          <div class="col mt5">
            <h4 class="card-title" style="text-align: center;"> Lütfen Bekleyiniz ... </h4>
          </div>
        </div>
      </div>
      <div class="card-body table-responsive">
        <div class="col-12" [hidden]="success">

          <ul class="list-group list-group-flush">
            <li *ngFor="let item of process" class="list-group-item justify-content-between">
              <span class="h6 font-weight-bold mb-0">{{item ? item.task :"" }}</span>
              <i class="fa fa-check-circle" style="color:#388d52" [hidden]="!item.status"></i>
            </li>
          </ul>

        </div>
        <div class="sweet-alert" [hidden]="!success" style="min-height:140px;">
          <div class="icon success animate">
            <span class="line tip animateSuccessTip"></span>
            <span class="line long animateSuccessLong"></span>
            <span class="placeholder"></span>
            <span class="fix"></span>
          </div>
        </div>

      </div>


    </div>
  </div>
</div>
